import type { PropsWithChildren } from 'react';
import { GovIcon, GovTooltip } from '@gov-design-system-ce/react';
import { Checkbox } from '@gov-design-system-ce/react-form';
import { useLocale } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';

const TriangleWarning = ({ tooltipKey }: { tooltipKey: string }) => {
	const { t } = useLocale(PageCode['datove-schranky']);

	return (
		<GovTooltip>
			<GovTooltip.Trigger>
				<GovIcon
					name="exclamation-triangle-fill"
					type="components"
					color="warning"
					size="2xl"
				/>
			</GovTooltip.Trigger>
			<GovTooltip.Content>{t(tooltipKey)}</GovTooltip.Content>
		</GovTooltip>
	);
};

const Wrapper = ({ children }: PropsWithChildren) => (
	<div className="ds-checkbox-item w-6">{children}</div>
);

interface LeftActionProps {
	name: string;
	isUnread: boolean;
	isLongUnread: boolean;
	isArchived: boolean;
	showCheckboxes: boolean;

	isChecked: boolean;
	onCheck: () => void;
}

export const LeftAction = ({
	name,
	onCheck,
	isChecked,
	isLongUnread,
	isUnread,
	isArchived,
	showCheckboxes,
}: LeftActionProps) => {
	if (isLongUnread) {
		return (
			<Wrapper>
				<TriangleWarning tooltipKey="zprava.varovani.nutna-akce" />
			</Wrapper>
		);
	}
	if (showCheckboxes) {
		if (isArchived) {
			return (
				<Wrapper>
					<TriangleWarning tooltipKey="zprava.varovani.jiz-archivovana" />
				</Wrapper>
			);
		}
		if (isUnread) {
			return (
				<Wrapper>
					<TriangleWarning tooltipKey="zprava.varovani.nutna-akce" />
				</Wrapper>
			);
		}

		return (
			<Wrapper>
				<Checkbox
					name={name}
					isChecked={isChecked}
					onChange={onCheck}
					hasNoLabel={true}
					size="m"
				/>
			</Wrapper>
		);
	}
};
